import React from 'react';
import isEmpty from 'lodash/isEmpty';
import styled from 'styled-components/macro';
import { Text } from '@podiumhq/design-system';
import { BusinessDetailsForm } from 'components/BusinessDetails';
import { useBusinessInfoContext } from 'contexts/BusinessContextProvider';
import {
  GoogleAutocompleteResultsList,
  GoogleAutocompleteResultsWrapper,
  GoogleAutocompleteImage,
} from 'components/GoogleAutocomplete';
import { MEDIUM_MEDIA_QUERY_WIDTH } from 'styles';
import { ContentWrapper, Subheading, Title } from '../../../styles';

const BusinessInfoContent = ({ isSubmitting }) => {
  const { gmb } = useBusinessInfoContext() || {};
  const labelText = isEmpty(gmb)
    ? "What's your business information?"
    : 'Business name';

  return (
    <ContentWrapper>
      <Title>
        Hundreds of happy customers, but only a few reviews? Let’s fix that.
      </Title>
      <Subheading>
        Connect your Google listing, then use Podium to text review invitations
        to customers. Make it super simple for customers to leave a review.
      </Subheading>

      <BusinessWrapper>
        <Text paddingBottom="8px" fontWeight="medium" fontSize="md">
          {labelText}
        </Text>
        <BusinessDetailsForm
          displayManualLink={true}
          isSubmitting={isSubmitting}
          showFullForm={isEmpty(gmb)}
          size="md"
          noResultsTitle="Hmm... we can't find your business on Google"
          enterManuallyText="Enter address manually"
          enterManuallyButtonProps={enterManuallyButtonProps}
          {...businessFieldIconProps}
        />
      </BusinessWrapper>
    </ContentWrapper>
  );
};

export default BusinessInfoContent;

const enterManuallyButtonProps = {
  color: 'silver.lightest',
  variant: 'primary',
  size: 'sm',
  padding: '4px 8px 4px 8px',
};

const businessFieldIconProps = {
  iconProps: {
    icon: 'Search',
    fillColor: 'black.lighter',
    size: 'sm',
    side: 'left',
  },
};

const BusinessWrapper = styled.div`
  max-width: 400px;
  ${GoogleAutocompleteResultsList} {
    max-height: 190px;
    max-width: 400px;
    overflow: auto;
  }

  ${GoogleAutocompleteResultsWrapper} {
    position: relative;
    min-width: 100%;
    max-width: 400px;
    left: 0;
    border-radius: 12px;
    box-shadow: 0 0 0 0.5px rgba(18, 21, 26, 0.08),
      0 4px 8px rgba(18, 21, 26, 0.04), 0 8px 16px -2px rgba(18, 21, 26, 0.04),
      0 16px 32px -4px rgba(18, 21, 26, 0.04);
  }

  ${GoogleAutocompleteImage} {
    height: 14px;
  }

  @media (max-width: ${MEDIUM_MEDIA_QUERY_WIDTH}px) {
    ${GoogleAutocompleteResultsWrapper} {
      width: 89%;
    }
  }
`;
